import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Input, theme, Typography } from "antd";
import { ColumnComponent, RowComponent } from "../components";
import { useEffect, useState } from "react";

export const SuccessUseCases = ({
  initialValue = [],
  onChangeSuccessUseCases,
}) => {
  const [successUseCases, setSuccessUseCases] = useState(initialValue);

  // Sincronizamos el valor de initialValue solo cuando cambia
  useEffect(() => {
    if (initialValue?.length > 0) {
      setSuccessUseCases(initialValue);
    }
  }, [initialValue]);

  // Notificar al padre cuando cambian los casos
  useEffect(() => {
    onChangeSuccessUseCases(successUseCases);
  }, [onChangeSuccessUseCases, successUseCases]);

  const {
    token: { colorError, /* colorBgContainer */ },
  } = theme.useToken();

  return (
    <ColumnComponent style={{ width: "100%" }}>
      <Button
        style={{ marginTop: 8, alignSelf: "end" }}
        disabled={successUseCases.length === 2}
        onClick={() => {
          setSuccessUseCases([
            ...successUseCases,
            {
              id: successUseCases.length
                ? successUseCases[successUseCases.length - 1].id + 1
                : 0,
              metric: "",
              description: "",
            },
          ]);
        }}
      >
        <PlusCircleOutlined />
        Agregar caso de éxito
      </Button>
      {successUseCases.length === 0 && <p style={{fontSize: "16px"}}>Capture Caso de éxito</p>}
      {successUseCases.length > 0 &&
        successUseCases.map((useCase, index) => (
          <RowComponent
            key={index}
            style={{ justifyContent: "space-around", alignItems: "center" }}
          >
            <ColumnComponent style={{ alignItems: "start", marginRight: 16 }}>
              <Typography.Text level={4} style={{ marginLeft: 38 }}>
                Métrica
              </Typography.Text>
              <RowComponent style={{ alignItems: "center" }}>
                <div
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 8,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", 
                    backgroundColor: "var(--color-primary)",
                    color: "#ffffff",
                    fontWeight: "bold",
                  }}
                >
                  {index + 1}
                </div>

                <Input
                  name="metric"
                  type="text"
                  size="large"
                  placeholder="Métrica (Ej: 99.91%)"
                  style={{ marginTop: 8 }}
                  value={useCase.metric}
                  onChange={(e) => {
                    const updatedUseCases = [...successUseCases];
                    updatedUseCases[index].metric = e.target.value;
                    setSuccessUseCases(updatedUseCases);
                  }}
                />
              </RowComponent>
            </ColumnComponent>

            <ColumnComponent style={{ alignItems: "start" }}>
              <RowComponent style={{ alignItems: "center" }}>
                <Input
                  name="description"
                  type="text"
                  size="large"
                  placeholder="Descripción (Ej: Reducción de tiempo en resolución)"
                  style={{ marginTop: 30 }}
                  value={useCase.description}
                  onChange={(e) => {
                    const updatedUseCases = [...successUseCases];
                    updatedUseCases[index].description = e.target.value;
                    setSuccessUseCases(updatedUseCases);
                  }}
                />
                <Button
                  type="primary"
                  shape="circle"
                  style={{ marginLeft: 8, backgroundColor: colorError }}
                  icon={<CloseCircleOutlined />}
                  onClick={() => {
                    const updatedUseCases = [
                      ...successUseCases.slice(0, index),
                      ...successUseCases.slice(index + 1),
                    ];
                    setSuccessUseCases(updatedUseCases);
                    /* onChangeSuccessUseCases(updatedUseCases); */
                  }}
                />
              </RowComponent>
            </ColumnComponent>
          </RowComponent>
        ))}
    </ColumnComponent>
  );
};
